import * as React from "react";
import type { SVGProps } from "react";
const SvgRemoveIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="remove_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M512 938.667c235.648 0 426.667-191.019 426.667-426.667S747.648 85.333 512 85.333 85.333 276.352 85.333 512 276.352 938.667 512 938.667zM853.333 512a341.333 341.333 0 1 1-682.666 0 341.333 341.333 0 0 1 682.666 0zm-512-42.667a42.667 42.667 0 1 0 0 85.334h341.334a42.667 42.667 0 1 0 0-85.334H341.333z"
    />
  </svg>
);
export default SvgRemoveIcon;
